import React from 'react';
import { TouchableOpacity, Text, StyleSheet, View, Switch, ActivityIndicator } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { TextMediumSize, TextMediumLargeSize, TextdefaultSize } from '../../constants/Fonts';

interface TouchActionProps {
  title: string;
  icon: string;
  handlePress: () => void;
  value?: boolean; // Switch state
  showSwitch?: boolean; // Whether to show switch
  loading?: boolean;
  error?: string;
  onText?: string; // Custom text for ON state
  offText?: string; // Custom text for OFF state
  showSwitchText?: boolean; // Whether to show on/off text
}

const TouchAction = ({ 
  title, 
  icon, 
  handlePress, 
  value = false, 
  showSwitch = false, 
  loading = false, 
  error = '',
  onText = 'ON',
  offText = 'OFF',
  showSwitchText = true
}: TouchActionProps) => {
  return (
    <TouchableOpacity style={[styles.item, showSwitch && styles.switchItem, error && styles.errorItem]}
      onPress={handlePress}
      disabled={loading}
    >
      {/* <View style={styles.iconContainer}>
        <FontAwesome5 name={icon} size={TextMediumLargeSize} color={error ? "#c62828" : "black"} style={{ marginBottom: 5 }}/>
      </View> */}
      
      <View style={styles.titleSwitchContainer}>
        <Text style={[
          styles.title,
          error && styles.errorText,
          showSwitch && styles.titleWithSwitch
        ]}>
          {title}
        </Text>
        
        {showSwitch && (
          <View style={styles.switchContainer}>
            {loading ? (
              <ActivityIndicator size="small" color="#0000ff" />
            ) : (
              <View style={styles.switchWithText}>
                <Switch
                  value={value}
                  onValueChange={handlePress}
                  trackColor={{ false: '#6c757d', true: '#2e96e1' }}
                  thumbColor={value ? '#ffc107' : '#f8f9fa'}
                  ios_backgroundColor="#343a40"
                  style={styles.switch}
                />
                {showSwitchText && (
                  <Text style={[
                    styles.switchText,
                    value ? styles.switchTextOn : styles.switchTextOff
                  ]}>
                    {value ? onText : offText}
                  </Text>
                )}
              </View>
            )}
          </View>
        )}
      </View>
      
      {error && (
        <View style={styles.errorIndicator}>
          <FontAwesome5 name="exclamation-triangle" size={12} color="#c62828" />
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  item: {
    alignItems: "center",
    flexBasis: "30%",
    padding: TextMediumSize,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#cacaca',
    marginTop: "2.5%",
    marginHorizontal: "4%",
    marginBottom: 5,
    shadowColor: '#b3b3b3',
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    elevation: 3,
    borderRadius: 8,
    minHeight: 120,
    justifyContent: 'center',
  },
  switchItem: {
    paddingVertical: TextMediumSize + 5,
    minHeight: 40,
  },
  errorItem: {
    borderColor: '#c62828',
    backgroundColor: '#ffebee',
  },
  iconContainer: {
    marginBottom: 15,
    alignItems: 'center',
  },
  title: {
    fontSize: TextdefaultSize,
    fontWeight: '500',
  },
  titleSwitchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  titleWithSwitch: {
    flex: 1,
    textAlign: 'center',
    marginRight: 0,
  },
  errorText: {
    color: '#c62828',
  },
  switchContainer: {
    alignItems: 'center',
  },
  switchWithText: {
    alignItems: 'center',
  },
  switch: {
    transform: [{ scaleX: 0.9 }, { scaleY: 0.9 }],
  },
  switchText: {
    fontSize: 10,
    fontWeight: '600',
    marginTop: 2,
    textAlign: 'center',
  },
  switchTextOn: {
    color: '#2e96e1',
  },
  switchTextOff: {
    color: '#6c757d',
  },
  errorIndicator: {
    position: 'absolute',
    top: 5,
    right: 5,
  },
});

export default TouchAction;